import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";
import store from '@/store/index.js';

// router setup
import routes from "./routes/routes";

// Plugins
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

import Chartist from "chartist";
import i18n from "./localization/i18n";
import GlobalComponents from "@/globalComponents";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

function loadSessionFromLocalStorage() {
  let auth = localStorage.getItem("auth");
  let user = JSON.parse(localStorage.getItem("user"));
  let email = localStorage.getItem("email");

  if (auth === null || auth === "") {
    return auth;
  }
    // TO-DO Decode and look for expired
  store.commit('setAuth', auth);
  store.commit('setUser', user);
  store.commit('setEmail', email);
  return auth;
}

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    let auth = store.state.auth || loadSessionFromLocalStorage();

    if (auth === null || auth === "") {
      next({ name: 'LandingPage'});
    } else {
      next();
    }
  } else {
    next();
  }
});

Vue.prototype.$Chartist = Chartist;

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(Notifications);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  i18n,
  data: {
    Chartist: Chartist
  }
});
